module.exports = __webpack_public_path__ + "img/torque.83b28609.jpg";